import React, { useEffect } from 'react';

import { showToast } from '@/globalFunction';
import { useToggle } from '@/hooks/useToggle';
import { queryClient } from '@/lib/react-query/react-query';

import Switch from '../../common/Switch/Switch';
import {
  legalConsentQueryKey,
  useGetLegalConsent,
} from '../../requestLegalConsent/api/getLegalConsent';
import { useUpdateLegalConsent } from '../../requestLegalConsent/api/updateLegalConsent';
import Card from '../Elements/Card';
import MainLayout from '../Elements/MainLayout';

const CookiePreferencesPage = () => {
  // @todo: attach from new api or current redux setting if this will be allowed to toggle
  const [alwaysEnabled] = useToggle(true);
  const [isSubscribeNewsletter, setIsSubscribeNewsletter] = useToggle(true);

  const getLegalConsentQuery = useGetLegalConsent({});
  const updateLegalConsentMutation = useUpdateLegalConsent({});

  useEffect(() => {
    if (!getLegalConsentQuery.data) return;
    setIsSubscribeNewsletter(getLegalConsentQuery.data.consents.newsletter);
  }, [getLegalConsentQuery.data, setIsSubscribeNewsletter]);

  const handleChangeSubcribeNewsletter = async () => {
    const updatedIsSubscribeNewsletter = !isSubscribeNewsletter;
    await updateLegalConsentMutation.mutateAsync({
      consents: {
        newsletter: updatedIsSubscribeNewsletter,
      },
    });

    setIsSubscribeNewsletter(updatedIsSubscribeNewsletter);
    showToast('success', 'Changes successsfully saved!');

    queryClient.setQueryData(legalConsentQueryKey, (prev: any) => {
      return {
        ...prev,
        consents: {
          ...prev.consents,
          newsletter: updatedIsSubscribeNewsletter,
        },
      };
    });
  };

  return (
    // <div
    //   className={clsx(
    //     'cookie-preference-spage',
    //     'tw-bg-cfo-grey-100 tw-grow tw-overflow-y-auto tw-px-[200px] tw-py-[50px]'
    //     // 'tw-p-[50px_150px]'
    //   )}
    // >
    <MainLayout>
      <Card className="tw-mb-[21px]">
        <div className="flex flex-col tw-p-[40px]">
          <h1 className="tw-text-center tw-text-[24px] tw-leading-[36px] tw-font[420] tw-gap-[10px] ">
            Manage Cookies
          </h1>
          <div className="details-container tw-flex tw-flex-col tw-gap-[40px] tw-text-[14px] tw-leading-[21px] tw-font[390]">
            <p className="tw-mt-[8px]">
              We use cookies to enhance your experience, and support with the
              development of and improvements to our WebApp, which may include
              the delivery of personalized content and ads.
            </p>
            <div className="tw-rounded-[11px] tw-border-solid tw-border-[1px] tw-p-[20px]">
              <div className="actions tw-flex tw-justify-between tw-h-[42px] tw-items-center">
                <span className="tw-text-[14px] tw-leading-[21px] tw-font[450] tw-font-brandonTextMedium">
                  Strictly Necessary
                </span>
                <div className="tw-flex tw-gap-[10px] tw-items-center">
                  <span className="tw-text-[14px] tw-leading-[21px] tw-font[420] tw-font-brandonTextMedium">
                    Always Enabled
                  </span>
                  <Switch
                    isActive={alwaysEnabled}
                    className="tw-h-[42px] tw-w-[42px]"
                    disabled={true}
                    tooltip={{
                      id: 'cookie-preference',
                      place: 'bottom',
                      content: 'You cannot change this setting',
                    }}
                  />
                </div>
              </div>
              <hr className="tw-mt-[5px] tw-mb-[5px]" />
              <p className="tw-text-[14px] tw-leading-[21px] tw-font[390] tw-pt-[10px]">
                Necessary cookies are absolutely essential for the WebApp to
                function properly. This category only includes cookies that
                ensures basic functionalities and security features of the
                WebApp. These cookies do not store any personal information.
              </p>
            </div>
          </div>
        </div>
      </Card>
      <Card>
        <div className="flex flex-col tw-p-[40px]">
          <h1 className="tw-text-center tw-text-[24px] tw-leading-[36px] tw-font[420] tw-gap-[10px] tw-pb-[40px]">
            Newsletter
          </h1>
          <div className="details-container tw-leading-[21px] tw-font[390]">
            <div className="tw-rounded-[11px] tw-border-solid tw-border-[1px] tw-p-[20px]">
              <div className="actions tw-flex tw-justify-between tw-h-[42px] tw-items-center">
                <span className="tw-text-[14px] tw-leading-[21px] tw-font[450] tw-font-brandonTextMedium">
                  Subscribe to our newsletters (optional)
                </span>
                <div className="tw-flex tw-gap-[10px] tw-items-center">
                  <Switch
                    isActive={isSubscribeNewsletter}
                    className="tw-h-[42px] tw-w-[42px]"
                    onChange={handleChangeSubcribeNewsletter}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </MainLayout>
  );
};

export default CookiePreferencesPage;
